import { render, staticRenderFns } from "./consultStatus.vue?vue&type=template&id=6d43bce0&scoped=true"
import script from "./consultStatus.vue?vue&type=script&lang=js"
export * from "./consultStatus.vue?vue&type=script&lang=js"
import style0 from "./consultStatus.vue?vue&type=style&index=0&id=6d43bce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d43bce0",
  null
  
)

export default component.exports